import {useUserStore} from '~/store/userStore.js'

const ALLOWED_USER_IDS = [1, 4, 98]

export function useWebsiteChatEnabled() {
    const config = useRuntimeConfig().public
    const userStore = useUserStore()

    const isTest = ['local', 'dev'].includes(String(config.APP_ENV)) || import.meta.dev

    return computed(() => {
        const userId = Number(userStore.user?.id)

        return isTest || (userStore.isAuthenticated && ALLOWED_USER_IDS.includes(userId))
    })
}
